// Admin auth helper. Uses in-memory flag + localStorage so that client-side
// navigation keeps the session even if storage is restricted. Will be replaced
// by JWT backend auth later.
let _authed = false;

export const setAuthed = (v) => {
  _authed = !!v;
  try {
    if (v) localStorage.setItem("intro_admin", "1");
    else { localStorage.removeItem("intro_admin"); localStorage.removeItem("intro_token"); }
  } catch (e) { /* storage may be unavailable */ }
};

export const isAuthed = () => {
  try {
    if (localStorage.getItem("intro_admin") === "1") return true;
  } catch (e) { /* ignore */ }
  return _authed;
};
